////
/// ============================================================================
/// COMPONENT / Cursor
/// ============================================================================
///
/// @group components
////

import MouseFollower from "mouse-follower";
import gsap from "gsap";

let cursor;

export default () => {
    if (!cursor) {
        MouseFollower.registerGSAP(gsap);

        cursor = new MouseFollower({
            stickDelta: 0.2,
            skewing: 4
        });
    }

    return cursor;
};
